import Login from '@/features/auth/login';
import OtpPage from '@/features/auth/otp-page';
import TryDemoPage from '@inPerformance/features/try-demo';
import CameraPermissions from '@inPerformance/features/camera-permission';
import ExercisePage from '@inPerformance/features/exercise';
import PostPerformance from '@inPerformance/features/post-performance';
import {
  DEVICE_PERFORMANCE_ROUTE,
  isDevicePerformanceDiagnosticEnabled,
} from '@inPerformance/services/device-performance';
import { lazy } from 'react';

const Home = lazy(() => import('@/pages/home/index.jsx'));
const MovexBuilderPage = lazy(() => import('@/pages/movex-builder/index.jsx'));
const PrescriptionBuilder = lazy(() => import('@/features/prescriptionBuilder/index.jsx'));
const DevicePerformanceDiagnostic = lazy(
  () => import('@inPerformance/features/device-performance/index.jsx')
);

const useRoutes = () => {
  // Clinician (movexStudio) screens. `ProtectedRoute` bounces a signed-out
  // visitor to /login, so nothing a guest needs to reach may live here.
  const privateRoute = [
    { route: '/home', element: <Home /> },
    { route: '/movex-builder', element: <MovexBuilderPage /> },
    { route: '/prescription-builder', element: <PrescriptionBuilder /> },
  ];

  // Auth screens only. `PublicRoute` bounces a signed-in user away from these
  // to /home, so nothing that a signed-in user needs to reach may live here.
  const publicRoute = [
    { route: '/login', element: <Login /> },
    { route: '/otp-page', element: <OtpPage /> },
  ];

  // The patient/guest exercise flow. Reached via a session link (sid +
  // session_token on the URL, see BuildPrescription), never a clinician
  // login — no ProtectedRoute/PublicRoute guard in either direction.
  const guestRoute = [
    { route: '/try-demo', element: <TryDemoPage /> },
    { route: '/exercise', element: <ExercisePage /> },
    { route: '/camera-permission', element: <CameraPermissions /> },
    { route: '/post-performance', element: <PostPerformance /> },
    // Developer-only device benchmark. Not registered at all in production or
    // with the flag off, so the URL falls through like any unknown path.
    ...(isDevicePerformanceDiagnosticEnabled()
      ? [{ route: DEVICE_PERFORMANCE_ROUTE, element: <DevicePerformanceDiagnostic /> }]
      : []),
  ];

  return { privateRoute, publicRoute, guestRoute };
};

export default useRoutes;
